export default __webpack_public_path__ + "static/media/right-arrow.aa7e1ed7.svg";